import type { AppTextareaEvent } from '@shared/ui/fields'

interface KanbanCommentFormOptions {
  onInputComment: (event: AppTextareaEvent) => void
  onSubmit: () => void
  onCancel: () => void
}

interface KanbanCommentFormReturn {
  handleInputComment: (event: AppTextareaEvent) => void
  handleClickSubmit: () => void
  handleClickCancel: () => void
}

export const useKanbanCommentForm = (options: KanbanCommentFormOptions): KanbanCommentFormReturn => {
  const handleInputComment = (event: AppTextareaEvent): void => {
    options.onInputComment(event)
  }

  const handleClickSubmit = (): void => {
    options.onSubmit()
  }

  const handleClickCancel = (): void => {
    options.onCancel()
  }

  return {
    handleInputComment,
    handleClickSubmit,
    handleClickCancel,
  }
}